import accountRoutes from './accountRoutes'
import attendanceRoutes from './attendanceRoutes'
import collectFeeRoutes from './collectFeeRoutes'
import enquiryRoutes from './enquiryRoutes'
import examinationRoutes from './examinationRoutes'
import reportRoutes from './reportRoutes'
import staffRoutes from './staffRoutes'
import studentRoutes from './studentRoutes'
import SubjectRoutes from './SubjectRoutes'
import StreamRoutes from './StreamRoutes'
import TimetableRoutes from './TimetableRoutes'
import payrollRoutes from './payrollRoutes'
import reportsRoutes from './reportsRoutes'
import transportRoutes from './transportRoutes'
import econtentRoutes from './econtentRoutes'
import admissionRoutes from './admissionRoutes'
import registrationRoutes from './registrationRoutes'
import batchUpgradationRoutes from './batchUpgradationRoutes'
import earlyAdmissionRoutes from './earlyAdmissionRoutes'
import baseRoutes from './baseRoutes'
import hubRoutes from './hubRoutes'
import otherRoutes from './otherRoutes'

const routes = [
  baseRoutes,
  SubjectRoutes,
  StreamRoutes,
  TimetableRoutes,
  payrollRoutes,
  reportsRoutes,
  reportRoutes,
  examinationRoutes,
  enquiryRoutes,
  transportRoutes,
  studentRoutes,
  staffRoutes,
  collectFeeRoutes,
  accountRoutes,
  attendanceRoutes,
  econtentRoutes,
  admissionRoutes,
  registrationRoutes,
  batchUpgradationRoutes,
  earlyAdmissionRoutes,
  hubRoutes,

  otherRoutes, // login, uiTesting, 404 etc.

]

export default routes
